import React from 'react'
import {
  Card, CardHeader, Row, Col, Badge, CardBody
} from 'reactstrap'
import { Bar } from 'react-chartjs-2'
import colorChats from '../../lib/colorChats'

const options = {
  legend: {
    display: false,
    position: 'top'
  },
  tooltips: {
    enabled: true,
    callbacks: {
      label: function(tooltipItem, data) {
        // var label = parseFloat(data.datasets[0].data[tooltipItem.index]).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) || 'R$ 00,00'
        var label = data.datasets[0].data[tooltipItem.index];
        
        var dataset = data.datasets[tooltipItem.datasetIndex];
        var total = dataset.data.reduce((total, currentElement) => parseFloat(total) + parseFloat(currentElement))
        // let total = 0;
        var valor = dataset.data[tooltipItem.index]
        var porcentagem = parseFloat((valor/total*100).toFixed(1))
        label += ' ('+porcentagem+'%)'
        return label
      },
      title: function(tooltipItem, data) {
        return data.labels[tooltipItem[0].index]
      },
    }
  },
  scales: {
    yAxes: [
      {
        ticks: {
          display: false,
          min: 0
        },        
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(255,255,255,0.1)"
          //color: "rgba(128,128,128,0.2)"
        }
      }
    ],
    xAxes: [
      {
        barPercentage: 0.8,
        gridLines: {
          drawBorder: true,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent"
        },
        ticks: {
          display: true
        }
      }
    ]
  }
}

const BarrasQtde = ({ title, color, dados }) => {
  var data='';

  if (typeof dados != "undefined") {

    data = {
      labels:dados.lojas,
      datasets: [
        {
          labels: dados.lojas,
          pointRadius: "0",
          pointHoverRadius: "0",
          backgroundColor: colorChats.vivida,
          borderWidth: "0",
          data: dados.valores
        }
      ]
    }
  
  } else {
      return (<></>)
  }

  return (
    <Card className='mb-0 mt-4'>
      <CardHeader>
        <Row>
          <Col sm="7">
            <div className="numbers pull-left grafico-valor">{dados.total}</div>
          </Col>
          <Col sm="5">
            <div className="pull-right">
              <Badge className={color} pill>
                {title}
              </Badge>
            </div>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Bar
          data={data}
          options={options}
          width={550}
          height={150}
        />
      </CardBody>
    </Card>
  )
}

export default BarrasQtde








